import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";
import { Path } from "react-native-svg";

export const IconArrowRightLeft: React.NamedExoticComponent<CentralIconBaseProps> = React.memo((props) => {
  return <CentralIconBase {...props} maskId="square-filled-radius-0-stroke-2-IconArrowRightLeft"><Path fillRule="evenodd" clipRule="evenodd" d="M16.0002 1.58594L21.4144 7.00015L16.0002 12.4144L14.5859 11.0002L17.5859 8.00015H3.00015V6.00015H17.5859L14.5859 3.00015L16.0002 1.58594ZM9.41436 13.0002L6.41436 16.0002H21.0002V18.0002H6.41436L9.41436 21.0002L8.00015 22.4144L2.58594 17.0002L8.00015 11.5859L9.41436 13.0002Z" fill="currentColor"/></CentralIconBase>;
});

export default IconArrowRightLeft;
